import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import { getDashboardPath, getOnboardingPath } from "../../constants";
import * as image from "../../constants/image";
import defaultPic from "../../assets/onboarding/default_pic.svg";
import * as actions from "../../store/actions";
import { signOutUrl } from "../../utils/urls";

import AutoCloseMenu from "./AutoCloseMenu";
import ProfileIcon from "./profileIcon";
import ProfileIcons from "../../components/uiElements/icons/profileIcons/ProfileIcon";
import SignoutModal from "../../components/uiElements/modal/SignoutModal";
import SocialShareModal from "../../components/uiElements/modal/SocialShareModal";
import { getUserData, saveRole } from "../../utils/localStorage";
import axios from "axios";
import { errorHandler, successHandler } from "../../store/actions/responseHandler";

let TopBar = ({
  logout,
  personalInfo,
  authInit,
  history,
  redirectedPath,
  location,
  updateUserRole,
  getUserDetailId,
  updateAvailablePermissionOnly,
  schedulerunner,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [modal, setShowModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);

  const isOnboarding = location.pathname.startsWith(getOnboardingPath());

  const userData = getUserData();

  const menuOptions = [
    {
      name: "My Profile",
      icon: "profile",
      onClick: () => history.push(getOnboardingPath("/step1")),
    },
    {
      name: "Share Profile",
      icon: "share",
      onClick: () => {
        history.push(getDashboardPath("/share-profile"));
      },
    },
    {
      name: "Change Password",
      icon: "key",
      onClick: () =>
        (!isOnboarding && history.push(getDashboardPath("/change-password"))) ||
        (redirectedPath && authInit("/change-password", true)),
    },
    {
      name: "Login as patient",
      icon: "userCheck",
      onClick: () => {
        saveRole("PATIENT");
        if (!getUserData().accepted_role.includes("PATIENT")) {
          updateUserRole();
        }
        getUserDetailId(() => {
          history.push(getOnboardingPath("/create-profile"));
          window.location.reload();
        });
      },
    },
    {
      name: "Share about UrgiDoctor",
      icon: "share",
      onClick: () => {
        setShareModal(true);
      },
    },
  ];


  const handleUserSignOut = () => {
    let logoutParam = {
      refresh_token: localStorage.getItem("refreshToken"),
      fcm_id: getUserData()?.fcm_id
    }

    axios.post(signOutUrl, logoutParam)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 201) {
          successHandler(res.message[0]);
        } else {
          errorHandler(res.message[0]);
        }
      })
      .catch(error => {
        console.log(error)
      })
      .finally( () => {
        setTimeout(()=>{
          logout();
        }, 1000)
      });
  };

return (
  <React.Fragment>
    {modal && (
      <SignoutModal
        isOpen={modal}
        onSuccess={() => {
          updateAvailablePermissionOnly(false);
          console.log("LOOGGED OUT <><><>")
          handleUserSignOut();
        }}
        closeModal={() => setShowModal(!modal)}
      />
    )}

    {shareModal && (
      <SocialShareModal
        isOpen={shareModal}
        closeModal={() => setShareModal(!shareModal)}
      />
    )}
    <div
      className=" px-4 "
      style={{
        backgroundColor: "var(--header-color)",
        paddingBottom: 20,
        paddingTop: 20,
      }}
    >
      <div className=" w-100 ml-auto d-flex justify-content-end align-items-center">
        <div className="mr-4">
          <img
            src={
              personalInfo?.photo?.src || userData?.image?.src || defaultPic
            }
            alt=""
            className="profile-image-secondary mr-2"
          />
          <ProfileIcon onArrowClick={() => setShowMenu(!showMenu)}>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                outline: "none",
                textTransform: "uppercase",
                color: "#747474",
              }}
              className="mr-2"
            >
              {" "}
              Dr. {userData?.firstName} {userData?.lastName}
            </span>

            <svg
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.293 0.292969L6.00003 4.58597L1.70703 0.292969L0.29303 1.70697L6.00003 7.41397L11.707 1.70697L10.293 0.292969Z"
                fill="#707070"
              />
            </svg>
          </ProfileIcon>
          <AutoCloseMenu showMenu={showMenu} setShowMenu={setShowMenu}>
            <div>
              {menuOptions.map(menu => (
                <p
                  style={{
                    cursor: "pointer",
                    color: "inherit",
                  }}
                  onClick={() => {
                    menu.onClick();
                    setShowMenu(false);
                  }}
                >
                  <ProfileIcons type={menu.icon} /> {menu.name}
                </p>
              ))}
            </div>
          </AutoCloseMenu>
        </div>
        <button
          className=" border-0 shadow-none ml-4"
          style={{ outline: "none", background: "var(--header-color)" }}
          onClick={() => setShowModal(true)}
        >
          <img
            height={26}
            className=""
            width={26}
            src={image.LOG_OUT_LOGO}
            alt=""
          />
        </button>
      </div>
    </div>
  </React.Fragment>
);
};

const mapStoreToProps = ({ onboarding, auth }) => ({
  personalInfo: onboarding.personalInfo,
  redirectedPath: auth.redirectToOnboardingPath,
});
const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(actions.logout()),
  authInit: (path, redirect) => dispatch(actions.authInit(path, redirect)),
  updateUserRole: () => dispatch(actions.updateUserRoleAction()),
  getUserDetailId: cb => dispatch(actions.getUserDetailIdAction(cb)),
  updateAvailablePermissionOnly: is_available =>
    dispatch(actions.updateAvailablePermissionOnly(is_available)),
  schedulerunner: () => dispatch(actions.schedulerunner()),
});

export default withRouter(connect(mapStoreToProps, mapDispatchToProps)(TopBar));
